<template>
  <div class="flex flex-col justify-center">
    <div class="mb-8">
      <h1
        class="flex justify-center w-auto font-serif text-3xl mt-10 mb-8 uppercase"
        :class="textGray400()">
          {{$t('catalog.brands')}}
      </h1>
      <div class="border-b border-gray-400 pl-4 pt-4">
          <div class="pb-1 font-bold uppercase"></div>
        </div>
    </div>
    <brands :productBrands="productBrands" class="mb-10" />
    <carousel-fixed class="my-20" />
  </div>
</template>

<script>
import ProductService from '@/services/ProductService';
import CarouselFixed from '@/components/graphics/CarouselFixed.vue';
import Brands from '@/components/graphics/Brands.vue';

export default {
  components: {
    CarouselFixed,
    Brands,
  },

  data() {
    return {
      productBrands: [],
    };
  },

  created() {
    ProductService.getAllProductBrands().then(({ data }) => {
      this.productBrands = data;
    });
  },

};
</script>
